import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
vue.use(vuex);

const departamento = new vapi({
    baseURL: `${process.env.VUE_APP_REST}/api/departamento`,
    namespaced : true,        
    state: {
        departametos: [],
        conteobydepto:0,
        conteodeptos: 0
    }
}).get({
    action: "getDepartamentos",      
    onSuccess: (state, payload) => {        
        state.departametos = payload.data;
    }
}).get({
    action: "getConteoIndicadoresbyDepto",   
    path: function (obj) {
        return `/ConteoIndicadoresDepartamentales/${obj.iddepartamento}`  
    },     
    onSuccess: (state, payload) => {        
        state.conteobydepto = payload.data;
    }
}).get({
    action: "getConteototalIndicadoresporDepto",   
    path: function() {
        return `/ConteoIndicadoresporDepto`  
    },     
    onSuccess: (state, payload) => {        
        state.conteodeptos = payload.data;
    }
}).getStore();

departamento.getters = {  
    gDepartamentos : state =>  {
        return state.departametos;
    },
    gConteobyDepto : state => {
        return state.conteobydepto;
    },
    gConteosDeptos : state => {
        return state.conteodeptos;
    }
}
export default departamento;